import Cookies from 'js-cookie';
import { call, takeLatest } from 'redux-saga/effects';

import type * as carrierFormInputActions from '~/actions/carrier-form-input.actions';

import { ActionKeys } from '~/actions/constants';
import { EBAY_CANADA_REGISTRATION_COOKIE_NAME } from '~/constants/cookies';
import {
  CarrierFormEventType,
  TabbedCarrierFormName,
} from '~/pages/Settings/Carriers/CarrierForm/CarrierForm';

export function* trackCarrierFormEvent(
  action: ReturnType<typeof carrierFormInputActions.trackCarrierFormEvent>,
) {
  const eventType = action.eventType;
  const formName = action.formName;

  const ebayCanadaConnectionStartCookie = Cookies.get(EBAY_CANADA_REGISTRATION_COOKIE_NAME);

  if (
    ebayCanadaConnectionStartCookie === 'true' &&
    formName === TabbedCarrierFormName.EbayCanadaPost &&
    (eventType === CarrierFormEventType.Close || eventType === CarrierFormEventType.Submit)
  ) {
    if (eventType === CarrierFormEventType.Close) {
      // Removal of the cookie when the form is submitted is handled in removeEbayRegistrationCookie below
      // to ensure the cookie only gets removed if the submit was successful.
      yield call(Cookies.remove, EBAY_CANADA_REGISTRATION_COOKIE_NAME, {
        domain: CONFIG.shippoRootUrl,
      });
    }
  }
}

function* removeEbayRegistrationCookie() {
  const ebayCanadaConnectionStartCookie = Cookies.get(EBAY_CANADA_REGISTRATION_COOKIE_NAME);

  if (ebayCanadaConnectionStartCookie === 'true') {
    yield call(Cookies.remove, EBAY_CANADA_REGISTRATION_COOKIE_NAME, {
      domain: CONFIG.shippoRootUrl,
    });
  }
}

export default [
  takeLatest(ActionKeys.CARRIER_FORM_INPUT_EVENT, trackCarrierFormEvent),
  takeLatest(
    [
      ActionKeys.CREATE_CARRIER_ACCOUNT_SUCCESS,
      ActionKeys.CONNECT_CARRIER_ACCOUNT_SUCCESS,
      ActionKeys.CLEAR_EBAY_CANADA_CONNECT_START_COOKIE,
    ],
    removeEbayRegistrationCookie,
  ),
];
